import { useSelector } from "react-redux";
import AnnouncementContainer from "../../../components/announcement/announcement";
import { IRootState } from "../../../redux/root.reducer";

const Announcement = () => {
    const { isLoading, data: announcements } = useSelector(
        (state: IRootState) => state.home.announcements,
    );
    return !isLoading ? (
        <AnnouncementContainer announcements={announcements} />
    ) : (
        <></>
    );
};

export default Announcement;
